// 사용자 앱 진입점.
// React Query Provider + Router 를 한 곳에서 마운트하고,
// 플랫폼 분기(웹/Capacitor)는 src/platform 추상화 모듈을 통해 처리한다.

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfirmProvider } from "@oo/ui";
import App from "./App.tsx";
// Pretendard 가변폰트(동적 서브셋) - 화면에 실제로 쓰인 한글 글자 subset 만 런타임에 다운로드해
// 모바일 데이터 사용을 최소화한다. self-host(번들 포함)라 오프라인/Capacitor 네이티브에서도 동작.
// font-display:swap 이라 폰트 로드 전에는 시스템 한글 폰트로 즉시 표시된다(FOIT 없음).
import "pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 모바일 데이터 환경을 고려해 기본 staleTime 을 약간 길게 잡는다.
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  // 루트 엘리먼트가 없는 경우는 index.html 손상 등 비정상 상황이다.
  throw new Error("root element not found");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
